import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
    BULK_PROCESS_SUCCESS,
    CLEAR_PRE_VERIFICATION_APPROVAL_STATE_DATA,
    CLEAR_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS,
    CREATE_PRE_VERIFICATION_APPROVAL_SUCCESS,
    FETCH_PRE_VERIFICATION_APPROVAL_SUCCESS,
    GET_PRE_VERIFICATION_APPROVAL_SUCCESS,
    PRE_VERIFICATION_UPLOAD_COUNT_DECREASE,
    PRE_VERIFICATION_UPLOAD_COUNT_INCREASE,
    SAVE_PRE_VERIFICATION_APPROVAL_QUERY,
    SAVE_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";
import Swal from "sweetalert2";


export const getResourceSuccess = ({data, count}) => {
    return {
        type: GET_PRE_VERIFICATION_APPROVAL_SUCCESS,
        data,
        count
    };
};

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_PRE_VERIFICATION_APPROVAL_QUERY,
        query
    };
};

export const createResourceSuccess = ({data}) => {
    return {
        type: CREATE_PRE_VERIFICATION_APPROVAL_SUCCESS,
        data
    };
};

export const fetchResourceSuccess = ({data}) => {
    return {
        type: FETCH_PRE_VERIFICATION_APPROVAL_SUCCESS,
        data
    };
};

export const clearData = () => {
    return {
        type: CLEAR_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS,
    }
};

export const clearPropsData = () => {
    return {
        type: CLEAR_PRE_VERIFICATION_APPROVAL_STATE_DATA,
    }
}

export const saveInitialData = (data) => {
    return {
        type: SAVE_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS,
        data
    }
};

export const preVerificationUploadCountDecrease = () => {
    return {
        type: PRE_VERIFICATION_UPLOAD_COUNT_DECREASE,
    }
}

export const preVerificationUploadCountIncrease = () => {
    return {
        type: PRE_VERIFICATION_UPLOAD_COUNT_INCREASE,
    }
}

export const getPreVerificationApprovalResource = () => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const {preVerificationApproval} = store.getState();
            const {query} = preVerificationApproval;
            const response = await axios.get(`/pre-verification-approval?${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            dispatch(getResourceSuccess(response.data));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};


export const getResourceForDownload = (columns, filters, name) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const {preVerificationApproval} = store.getState();
            const {query} = preVerificationApproval;
            const response = await axios.get(`/pre-verification-approval/download?columns=${columns}&${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            const str = arrayToCSV(response.data, filters, columns);
            downloadCSV(str, name);
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const createResource = (payload, update) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            let formData = new FormData();

            payload && payload.assetDetails && payload.assetDetails.length && await Promise.all(payload.assetDetails.map(async (item, index) => {
                item.documents && item.documents.length && await item.documents.map((itm, ind) => {
                    var file = itm.file;
                    var blob = file.slice(0, file.size, file.type);
                    const newFile = new File([blob], `${item['tempAssetCode']}-index-${ind}`, {type: file.type});
                    formData.append(`files`, newFile);
                    let data = {...itm};
                    delete data.file;
                    item['documents'][ind] = data;
                });

                item.photos && item.photos.length && await item.photos.map((photo, indx) => {
                    if (photo && photo['file'] && !photo['url']) {
                        var file = photo.file;
                        var blob = file.slice(0, file.size, file.type);
                        const newFile = new File([blob], `${item['tempAssetCode']}-photos-index-${indx}`, {type: file.type});
                        formData.append(`files`, newFile);
                        let data = {...photo};
                        delete data.file;
                        item['photos'][indx] = data;
                    }
                })
            }));

            let assetDetails = [];
            payload.assetDetails && payload.assetDetails.length && await payload.assetDetails.map((item, index) => {
                let data = {...item};
                assetDetails.push(data);
            });

            if (assetDetails.length) {
                formData.append('assetDetails', JSON.stringify(assetDetails));
            }
            formData.append('pvNo', payload.pvNo);
            const response = await axios.post(`/pre-verification-approval`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
            dispatch(fetchSuccess());

            let message = '';
            let isOk = false;
            if (response && response.data && response.data.code && response.data.code === 201) {
                message = `<span style="color: tomato">${response.data.message}</span>`;
            } else if (response && response.data && response.data.message) {
                message = response.data.message;
                isOk = true;
            }
            // message.success('Report Submission is under process, please check after some time');
            Swal.fire({
                title: `<strong>PV Approval Status</strong>`,
                html: `<div><p>Report Submission is under process, please check after some time!</p><p>${message}</p></div>`,
                icon: isOk ? 'success' : 'warning'
            });
            dispatch(getPreVerificationApprovalResource());
            history.push(`/pre-verification-approval`);
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const fetchResource = (id) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/pre-verification-approval/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({data: response.data}));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const bulkApproveWithDefaultValue = (payload) => {
    // console.log(payload)
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/pre-verification-approval/bulk-approval`, payload);
            dispatch(fetchSuccess());
            // console.log(response);
            message.info(`Approval is running in the background. A confirmation email/notification will be sent once it finishes — please do NOT retry this PV until you have checked the email/notification for its status.`, 10)
            dispatch(bulkApproveWithDefaultValueSuccess({data: response.data}));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const bulkApproveWithDefaultValueSuccess = ({data}) => {
    return {
        type: BULK_PROCESS_SUCCESS,
        data
    };
};

export const deleteResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.delete(`/pre-verification/${id}`);
            if (response && response.data && response.data.deletedCount) {
                message.success('Record deleted successfully');
            }
            dispatch(fetchSuccess());
            dispatch(getPreVerificationApprovalResource());
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};
